import { render } from "./App.vue?vue&type=template&id=5080be9e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5080be9e&lang=css"

import exportComponent from "/Users/andrewdrury/Desktop/code/website/altPhoto/photography/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__